if (!customElements.get("product-buy-now")) {
  customElements.define(
    "product-buy-now",
    class ProductBuyNow extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button");
        this.handleClick = this.handleClick.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
        this.handleVariantInputChange = this.handleVariantInputChange.bind(this);
      }

      connectedCallback() {
        if (!this.button) return;

        this.form = document.getElementById(this.button.dataset.productForm);
        this.variantInput = this.form?.querySelector('[name="id"]');
        this.button.addEventListener("click", this.handleClick);
        this.variantInput?.addEventListener("change", this.handleVariantInputChange);
        window.addEventListener("pageshow", this.handlePageShow);
        this.wiggleInterval = window.setInterval(() => this.triggerWiggle(), 15000);

        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.button.dataset.sectionId) return;

            const submitButton = event.data.html.getElementById(
              `ProductSubmitButton-${this.button.dataset.sectionId}`
            );
            this.button.disabled = !event.data.variant?.available || submitButton?.hasAttribute("disabled") !== false;
          });
        }
      }

      disconnectedCallback() {
        if (!this.button) return;

        this.button.removeEventListener("click", this.handleClick);
        this.variantInput?.removeEventListener("change", this.handleVariantInputChange);
        window.removeEventListener("pageshow", this.handlePageShow);
        this.variantChangeUnsubscriber?.();
        window.clearInterval(this.wiggleInterval);
        window.clearTimeout(this.wiggleTimeout);
      }

      async handleClick() {
        if (this.button.disabled || this.button.getAttribute("aria-disabled") === "true") return;

        if (!this.form || !this.variantInput?.value) {
          this.showError(window.variantStrings?.unavailable || "This product is unavailable.");
          return;
        }

        this.setLoading(true);
        this.showError();

        try {
          const clearResponse = await fetch(`${window.routes?.cart_url || "/cart"}/clear.js`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });

          if (!clearResponse.ok) {
            throw new Error("Unable to prepare checkout. Please try again.");
          }

          const items = this.getCheckoutItems();
          const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || "Unable to add this product to your cart.");
          }

          window.location.assign(this.button.dataset.checkoutUrl || "/checkout");
        } catch (error) {
          this.showError(error.message);
          this.setLoading(false);
        }
      }

      getCheckoutItems() {
        const formData = new FormData(this.form);
        const properties = {};

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)]$/);
          if (propertyMatch && value !== "") properties[propertyMatch[1]] = value;
        });

        const currentItem = {
          id: Number(this.variantInput.value),
          quantity: Math.max(1, Number(formData.get("quantity")) || 1),
        };
        const sellingPlan = formData.get("selling_plan");

        if (Object.keys(properties).length) currentItem.properties = properties;
        if (sellingPlan) currentItem.selling_plan = Number(sellingPlan);

        const items = [currentItem];
        const productInfo = this.closest("product-info");
        const selectedUpsells = productInfo?.querySelectorAll('input[data-item="upsell"]:checked') || [];

        selectedUpsells.forEach((input) => {
          if (!input.value) return;
          items.push({
            id: Number(input.value),
            quantity: 1,
          });
        });

        return items;
      }

      handlePageShow() {
        this.setLoading(false);
      }

      handleVariantInputChange() {
        if (!this.variantInput.value) this.button.disabled = true;
      }

      triggerWiggle() {
        if (this.button.disabled || this.button.getAttribute("aria-disabled") === "true" || document.hidden) return;

        this.button.classList.add("buy-now-wiggle");
        window.clearTimeout(this.wiggleTimeout);
        this.wiggleTimeout = window.setTimeout(() => {
          this.button.classList.remove("buy-now-wiggle");
        }, 1200);
      }

      setLoading(isLoading) {
        this.button.classList.toggle("loading", isLoading);
        this.button.toggleAttribute("aria-disabled", isLoading);
        this.button.querySelector(".loading__spinner")?.classList.toggle("hidden", !isLoading);
      }

      showError(message = "") {
        const wrapper = this.closest(".qty-and-atc-btn")?.querySelector(".product-form__error-message-wrapper");
        const errorMessage = wrapper?.querySelector(".product-form__error-message");

        if (!wrapper || !errorMessage) return;

        errorMessage.textContent = message;
        wrapper.toggleAttribute("hidden", !message);
      }
    }
  );
}
